export class Documento {
    id: number;
    orden: string;
    fechaInicio: string;
    fechaFin: string;
    nombre: string;
    enlace: string;
    duracion: string;
}



// WEBPACK FOOTER //
// ./src/models/documento.ts